import { CoolingRegimesTabEditable } from "./CoolingRegimesTabEditable";
import { ProductNamesTab } from "./ProductNamesTab";
import { ProductCharacteristicsTab } from "./ProductCharacteristicsTab";
import { DetailTab } from "../DetailDrawer";
import { ProductTab } from "./ProductTab";
import { RegulatoryFeaturesTab } from "./RegulatoryFeaturesTab";
import { CropDetailsTab } from "./CropDetailsTab";

export function getProductDetailTabs({
  productCode,
}: {
  productCode: string;
}): DetailTab[] {
  return [
    {
      label: "Product",
      content: <ProductTab productId={productCode} />,
    },
    {
      label: "Reglementaire kenmerken",
      content: <RegulatoryFeaturesTab productId={productCode} />,
    },
    {
      label: "Productkenmerken",
      content: <ProductCharacteristicsTab productId={productCode} />,
    },
    {
      label: "Benamingen",
      content: <ProductNamesTab productId={productCode} />,
    },
    {
      label: "Gewasdetails",
      content: <CropDetailsTab productId={productCode} />,
    },
    {
      label: "Koelregimes",
      content: <CoolingRegimesTabEditable productId={productCode} />,
    },
  ];
}
